export const getDayNumber = (dayName) => {
  const daysOfWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  const index = daysOfWeek.indexOf(dayName);

  // If the input dayName is valid, return the corresponding index (0 to 6)
  // If not valid, return -1 to indicate an error
  return index !== -1 ? index + 1 : -1;
};

// Output Like 3 for Tuesday
